

import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';


import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

// app classes
import { Apisettings, APISETTINGS } from './classes/appConfig';

// Interceptors
import { JwtModule } from '@auth0/angular-jwt';
import { EnvServiceProvider } from './baseurl/env.service.provider';
import { PopUpComponent } from './inicio/pop-up/pop-up.component';
import { TokenExpiredInterceptor } from './interceptors/tokenExpired.interceptor';
export function tokenGetter() {
  return sessionStorage.getItem('JWT');
}

registerLocaleData(localeEs);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    NgbModule,
    ToastrModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        authScheme: '',
        allowedDomains: ['sevilla.org']
        // allowedDomains: ["example.com"],
        // disallowedRoutes: ["http://example.com/examplebadroute/"],
      },
    }),
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    PopUpComponent,
  ],
  providers: [
    EnvServiceProvider,
    {
      provide: LOCALE_ID,
      useValue: 'es'
    },
    {
      provide: Apisettings,
      useValue: APISETTINGS
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenExpiredInterceptor,
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
